<template>
  <div>
    <h3 class="middle-title">날짜선택</h3>
    <div class="calendar-date-box">
      <vue-monthly-picker
        :inputClass="{'input': isDisplayInput}"
        :monthLabels="locale"
        @selected="changeChalendar"
        v-model="calendarDate">
      </vue-monthly-picker>
    </div>
    <div class="calendar-wrapper">
      <div class="booking-label-wrapper booking-legend-wrapper">
        <span class="booking-legend">
          <span class="booking-legend__swatch pattern1" aria-hidden="true"></span>
          <span class="booking-legend__text">사용승인</span>
        </span>
        <span class="booking-legend">
          <span class="booking-legend__swatch pattern3" aria-hidden="true"></span>
          <span class="booking-legend__text">승인 대기중</span>
        </span>
        <span class="booking-legend">
          <span class="booking-legend__swatch pattern2" aria-hidden="true"></span>
          <span class="booking-legend__text">결제대기</span>
        </span>
      </div>
      <table class="calendar-table">
        <caption>날짜별 공간대관</caption>
        <thead>
        <tr>
          <th style="" class="th-first">시간</th>
          <th style="" colspan="2">09</th>
          <th style="" colspan="2">10</th>
          <th style="" colspan="2">11</th>
          <th style="" colspan="2">12</th>
          <th style="" colspan="2">13</th>
          <th style="" colspan="2">14</th>
          <th style="" colspan="2">15</th>
          <th style="" colspan="2">16</th>
          <th style="" colspan="2">17</th>
          <th style="" colspan="2">18</th>
          <th style="" colspan="2">19</th>
          <th style="" colspan="2">20</th>
        </tr>
        </thead>
        <tbody>
        <tr class="" v-for="tr in trByBookingList()">
          <td style="td-first" v-if="tr.tdVisible">{{tr.day}}일</td>
          <td style="" v-for="time in times(tr.bookingList)" v-if="time.visible" :class="time.status"
              :title="time.status === 'EMPTY' ? null : time.statusKo">
            <span class="calendar-td-group-name"></span><p class="alt-text">{{time.statusKo}}</p></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import moment from 'moment';
  import Datepicker from 'vuejs-datepicker';
  import VueMonthlyPicker from '../../common-modules/MonthlyPicker.vue';
  import CommonFn from '../../common-functions/commonFuntions';

  const commonFn = new CommonFn();
  export default {
    name: 'calendar-by-date',
    props: ['room'],
    components: {
      Datepicker,
      VueMonthlyPicker,
    },
    data() {
      return {
        url: '/api/bookings/room',
        progressing: false,
        format: 'MM월',
        inputClass: 'calendar-date-box__current-date display-inline',
        calendarDate: '',
        booking: [],
        selectedId: '',
        locale: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        isDisplayInput: false,
        baseTimes: ['0900', '0930', '1000', '1030', '1100', '1130', '1200',
          '1230', '1300', '1330', '1400', '1430', '1500', '1530', '1600', '1630', '1700', '1730', '1800', '1830', '1900', '1930', '2000', '2030'],
        startTimes: ['0900', '0930', '1000', '1030', '1100', '1130', '1200',
          '1230', '1300', '1330', '1400', '1430', '1500', '1530', '1600', '1630', '1700', '1730', '1800', '1830', '1900', '1930', '2000', '2030'],
        durations: Array.from(Array(25).keys()).slice(1),
        startTimeIndex: {},
        durationIndex: {},
        year: '',
        mon: '',
        date: '',
      };
    },
    methods: {
      getParams() {
        const url = window.location.search.substring(1);
        this.selectedId = commonFn.parseQueryString(url).id;
      },
      getBookingListByMonth() {
        axios.get(this.url, { params: { id: this.selectedId, month: this.date } }).then((res) => {
          this.booking = res.data || [];
        }).catch(e => console.log(e));
      },
      changeChalendar() {
        this.year = this.calendarDate.format('YY');
        this.mon = this.calendarDate.format('MM');
        this.date = `${this.year}${this.mon}`;
        this.getBookingListByMonth();
      },
      getStatusBookingListByRoom(day) {
        const bookings = [];
        const bookingList = this.booking;
        for (let i = 0; i < bookingList.length; i += 1) {
          if (bookingList[i].date.slice(4) === day.toString()) {
            bookings.push(bookingList[i]);
          }
        }
        bookings.sort((a, b) => {
          if (a.status > b.status) {
            return -1;
          } else if (a.status < b.status) {
            return 1;
          }
          return 0;
        });
        return bookings;
      },
      times(bookingList) {
        const trTime = [];
        const baseTimes = this.baseTimes;
        for (let i = 0; i < baseTimes.length; i += 1) {
          const visibleValue = true;
          let statusValue = 'EMPTY';
          let statusKorean = '비어있음';
          let selectedBooking = {};
          for (let j = 0; j < bookingList.length; j += 1) {
            const startTime = parseInt(bookingList[j].startTime, 10);
            const endTime = parseInt(bookingList[j].endTime, 10);
            if (parseInt(baseTimes[i], 10) >= startTime && parseInt(baseTimes[i], 10) < endTime) {
              statusValue = bookingList[j].status;
              if (bookingList[j].status === 'DONE' || bookingList[j].status === 'LECTURE') {
                statusValue = 'pattern1';
                statusKorean = '사용승인';
              } else if (bookingList[j].status === 'NEGOTIATION') {
                statusValue = 'pattern3';
                statusKorean = '승인 대기중';
              } else if (bookingList[j].status === 'PAYMENT_WAITING') {
                statusValue = 'pattern2';
                statusKorean = '결제대기';
              }
              selectedBooking = bookingList[j];
            }
          }
          trTime.push({ status: statusValue,
            visible: visibleValue,
            booking: selectedBooking,
            statusKo: statusKorean,
          });
        }
        return trTime;
      },
      trByBookingList() {
        const trList = [];
        const startDay = moment(`20${this.year}${this.mon}`, 'YYYYMM');
        const endDay = startDay.endOf('month').format('DD');
        for (let i = 0; i < endDay; i += 1) {
          const rowCount = 1;
          const tdVisibleValue = true;
          let dayValue = i + 1;
          if (dayValue < 10) {
            dayValue = `0${dayValue}`;
          }
          const doneBookingList = this.getStatusBookingListByRoom(dayValue);
          trList.push({ rowSpan: rowCount,
            day: dayValue,
            tdVisible: tdVisibleValue,
            bookingList: doneBookingList,
          });
        }
        return trList;
      },
      getDate() {
        const getMoment = moment().locale('ko');
        const today = getMoment.format('MM월');
        this.today = getMoment.format('YYMMDD');
        this.year = getMoment.format('YY');
        this.mon = getMoment.format('MM');
        this.date = getMoment.format('YYMM');
        this.calendarDate = today;
        $('input[name=calendarDate]').val(today);
      },
    },
    created() {
    },
    mounted() {
      this.getDate();
      this.getParams();
      this.getBookingListByMonth();
      this.startTimes.forEach((value, index) => (this.startTimeIndex[value] === index));
      this.durations.forEach((value, index) => (this.durationIndex[value] === index));
    },
  };
</script>
<style lang="scss">
  caption {overflow:hidden;position:absolute;top:0;left:0;width:1px;height:1px;font-size:0;line-height:0}

  /* 상태 표시 패턴 — 범례 스와치와 표 셀이 같은 클래스를 공유한다.
     색상 외에 무늬의 '형태'(가는 사선 / 세로 줄무늬 / 바둑판)로도 구별되도록 함 (WCAG 1.4.1) */
  .pattern1 {background-color: #00695c;
    background-image: repeating-linear-gradient(45deg, #ffffff 0, #ffffff 2px, #00695c 2px, #00695c 7px)}
  .pattern3 {background-color: #1b5faa;
    background-image: repeating-linear-gradient(90deg, #ffffff 0, #ffffff 3px, #1b5faa 3px, #1b5faa 10px)}
  .pattern2 {background-color: #d2521a;
    background-image: linear-gradient(45deg, #ffffff 25%, transparent 25%, transparent 75%, #ffffff 75%),
                      linear-gradient(45deg, #ffffff 25%, transparent 25%, transparent 75%, #ffffff 75%);
    background-position: 0 0, 6px 6px; background-size: 12px 12px}

  /* 범례 — 무늬는 스와치가, 가독성은 텍스트가 담당하도록 분리 (글자 위에 무늬를 깔지 않는다) */
  .booking-label-wrapper.booking-legend-wrapper {position: static; text-align: right; padding: 6px 0}
  .booking-legend {display: inline-flex; align-items: center; margin-left: 18px; white-space: nowrap}
  .booking-legend__swatch {display: inline-block; width: 40px; height: 20px; margin-right: 8px;
    border: 1px solid #767676; flex: none}
  .booking-legend__text {font-size: 14px; font-weight: 600; color: #222}
  @media (max-width: 767px) {
    .booking-legend {margin: 0 0 4px 12px}
  }
</style>


// WEBPACK FOOTER //
// CalendarByDate.vue?29349a12